import { CheckCircle2 } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { assetUrl } from "@/lib/api";

export default function About({ about }) {
  if (!about) return null;
  const paragraphs = (about.body || "").split("\n").filter(Boolean);
  return (
    <section id="about" className="relative overflow-hidden bg-[#FAF9F5] py-24 lg:py-32" data-testid="about-section">
      <div className="pointer-events-none absolute -left-32 top-1/4 h-[380px] w-[380px] rounded-full bg-[#0E8A8A]/5 blur-[110px]" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-5 lg:grid-cols-2 lg:gap-20 lg:px-8">
        <Reveal className="relative order-2 lg:order-1">
          <div className="absolute -left-4 -top-4 h-full w-full rounded-2xl border-2 border-[#B8860B]/30" />
          <div className="absolute -bottom-6 -right-6 h-24 w-24 rounded-full bg-[#0E8A8A]/10 blur-2xl" />
          <img
            src={assetUrl(about.imageUrl)}
            alt="About Omshubharidhaan"
            className="relative aspect-[4/3] w-full rounded-2xl object-cover shadow-[0_30px_60px_-30px_rgba(15,27,43,0.35)]"
            data-testid="about-image"
          />
        </Reveal>
        <div className="order-1 lg:order-2">
          <SectionHead index="00" label="About Us" title={about.title} description={about.subtitle} testId="about-head" />
          <div className="-mt-6 space-y-4">
            {paragraphs.map((p, i) => (
              <Reveal key={i} delay={0.1 + i * 0.06}>
                <p className="text-sm leading-relaxed text-[#5A6578] sm:text-base">{p}</p>
              </Reveal>
            ))}
          </div>
          {(about.points || []).length > 0 && (
            <Reveal delay={0.3}>
              <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-testid="about-points">
                {about.points.map((pt, i) => (
                  <li key={i} className="flex items-start gap-2.5 text-sm font-medium text-[#1B3A5C]">
                    <CheckCircle2 size={16} className="mt-0.5 shrink-0 text-[#0E8A8A]" />
                    {pt}
                  </li>
                ))}
              </ul>
            </Reveal>
          )}
        </div>
      </div>
    </section>
  );
}
